<template>
  <div>         
    <div class="container">  
      <b-navbar>
          <template #start>
              <b-navbar-item v-bind:href="apiUrl">
                <span class="content is-size-2 has-text-weight-bold">
                  <font-awesome-icon icon="film" /> Rollideo
                </span>
              </b-navbar-item>
          </template>
          <template #end>
              <b-navbar-dropdown label="API">
                  <b-navbar-item v-bind:href="apiUrl + '/apistep'">
                      <strong>API Quick Start</strong>
                  </b-navbar-item>
                  <b-navbar-item v-bind:href="apiUrl + '/apiguide'">
                      <strong>API documentation</strong>
                  </b-navbar-item>
              </b-navbar-dropdown>

              <b-navbar-item href="https://rollideo.com/blog/mainpage">
                  <strong>Blog</strong>
              </b-navbar-item>

               <b-navbar-item v-bind:href="apiUrl + '/contact'">
                  <strong>Contact</strong>
              </b-navbar-item>

              <b-navbar-item v-bind:href="apiUrl + '/subscribe'">       
                  <strong>Sign up</strong>
              </b-navbar-item>

              <b-navbar-item v-bind:href="apiUrl + '/login'">
                  <strong>Log in</strong>
              </b-navbar-item>
          </template>
      </b-navbar>
      <div class="box has-background-grey-lighter" >
  
  <h1 class="title is-3 has-text-centered has-text-info">Contact Rollideo</h1>

    <!-- our signup form ===================== -->
    <form id="signup-form" @submit.prevent="processForm">
      <!-- name -->
      <div class="field">
        <label class="label">Name</label>
        <input type="text" class="input" name="name" v-model="name">
      </div>

      <!-- email -->
      <div class="field">
        <label class="label">E-mail</label>
        <input type="email" class="input" name="email" v-model="email">
      </div>

      <!-- subject -->
      <div class="field">
        <label class="label">Subject</label>
        <input type="text" class="input" name="subject" v-model="subject">
      </div>

      <!-- text area -->
      <div class="field">
      <label class="label">Message</label>
        <textarea class="textarea" v-model="messbody"></textarea>
      </div>

      <!-- submit button -->
      <div class="field has-text-right">
        <button type="submit" class="button is-primary">Send a message</button>
      </div>
    </form>

       </div>
      </div>

      <footer class="footer">
        <nav class="level">

          <div class="level-item has-text-centered">
              <a v-bind:href="apiUrl + '/about'">About Rollideo</a> 
          </div>
                 
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/terms'">Terms of service</a> 
            </div>
          </div>

        </nav>  
      </footer>

  </div>    
</template>

<script>
import axios from 'axios'
export default {
    data () {
            return {
              name: null,
              email: null,
              subject: null,
              messbody: null,
              retourmessage: '',
              apiUrl : ''
            }
    }, 
    methods: {
      sendMessage(payload) {
        var api_url = this.apiUrl;
        api_url += '/pagecontact';
        axios.post(api_url, payload)
          .then(response => {
          this.retourmessage = response.data.messageretour
          })
          .catch((error) => {
            console.log(error);
          });
      }, 
      processForm () {
        if (!this.name || !this.email || !this.subject || !this.messbody) {
          alert("Please complete all the fields");
        } else {
          const payload = {
            name: this.name,
            subject: this.subject,
            messbody: this.messbody,
            email: this.email
          };
          this.sendMessage(payload);
          alert("Message sent");
        }
      }
    }, 
    created () {
      this.apiUrl = process.env.API_URL;
    } 
  }
</script>





// WEBPACK FOOTER //
// src/components/Contact.vue